import { Bookmark, Headphones, Share2, Sparkles, Minus, Plus } from "lucide-react";
import { useSaved } from "@/hooks/useSaved";
import { toast } from "sonner";

const Btn = ({ testid, onClick, active, children }) => (
  <button data-testid={testid} onClick={onClick}
    className={`flex shrink-0 items-center gap-2 rounded-full px-4 py-2.5 text-sm font-bold transition-colors ${active ? "bg-primary text-white" : "bg-muted hover:bg-foreground hover:text-background"}`}>
    {children}
  </button>
);

export function ArticleActions({ a, onListen, listening, onSummary, summary, onShare, font, setFont }) {
  const { isSaved, toggle } = useSaved();
  const saved = isSaved(a.id);
  return (
    <div className="no-scrollbar -mx-4 flex items-center gap-2 overflow-x-auto px-4 py-1 sm:mx-0 sm:px-0">
      <Btn testid="article-listen-btn" onClick={onListen} active={listening}><Headphones size={16} />Ouvir</Btn>
      <Btn testid="article-summary-btn" onClick={onSummary} active={summary}><Sparkles size={16} />Resumir em 3 pontos</Btn>
      <Btn testid="article-share-btn" onClick={onShare}><Share2 size={16} />Partilhar</Btn>
      <Btn testid="article-save-btn" active={saved} onClick={() => toast(toggle(a) ? "Notícia guardada" : "Removida dos guardados")}>
        <Bookmark size={16} fill={saved ? "currentColor" : "none"} />{saved ? "Guardado" : "Guardar"}
      </Btn>
      <div className="ml-auto flex shrink-0 items-center rounded-full bg-muted">
        <button data-testid="font-decrease-btn" onClick={() => setFont(Math.max(15, font - 1))} className="grid h-10 w-10 place-items-center" aria-label="Diminuir letra"><Minus size={14} /></button>
        <span className="font-serif-display text-sm font-bold">Aa</span>
        <button data-testid="font-increase-btn" onClick={() => setFont(Math.min(24, font + 1))} className="grid h-10 w-10 place-items-center" aria-label="Aumentar letra"><Plus size={14} /></button>
      </div>
    </div>
  );
}
